export default __webpack_public_path__ + "static/media/Flag_of_Bahamas.139f285d.svg";